let AiSettings = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
    },

    form: function () {
        let _this = this;
        let aiSettingsForm = $('.ai-settings-form');
        let submitBtn = Ladda.create(aiSettingsForm.find('[type=submit]')[0]);

        aiSettingsForm.on('submit', function () {
            submitBtn.start();
        })


        let valuesForSlider = [1,2,3,4,5,6,7,8,9,10];
        let format = {
            to: function(value) {
                return valuesForSlider[Math.round(value)];
            },
            from: function (value) {
                return valuesForSlider.indexOf(Number(value));
            }
        };

        let weightSliderBlueprint = document.getElementById('ai_weight_blueprint');
        let weightSliderVideo = document.getElementById('ai_weight_video');
        let weightSliderAudio = document.getElementById('ai_weight_audio');
        let weightSliderUser = document.getElementById('ai_weight_user');
        let config = {
            ticks: [1,2,3,4,5,6,7,8,9,10],
            ticks_labels: [1,2,3,4,5,6,7,8,9,10],
        };
        $(weightSliderBlueprint).slider(config);
        $(weightSliderVideo).slider(config);
        $(weightSliderAudio).slider(config);
        $(weightSliderUser).slider(config);
    },
};

$().ready(function () {
    window.AiSettings = AiSettings;
    window.AiSettings.init();
});